import AngularLink from "../../../global/components/AngularLink/AngularLink.vue";
import PageTabTitle from "../../../global/components/PageTabTitle/PageTabTitle.vue";
import PuxIcon from "../../../global/components/PuxIcon/PuxIcon.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";
import SmartTable from "../../../global/components/table/table.vue";

import getTableApi from "../../../const/TableApis";

const TABLE_ID = "FoerderorganisationBearbeitenTable";

// @vue/component
export default {
  name: "FoerderorganisationBearbeitenList",
  components: {
    AngularLink,
    PageTabTitle,
    PuxIcon,
    PuxTranslate,
    SmartTable,
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        cols: [
          {
            label: "_LBL_FOERDERORGANISATION_BEARBEITEN_LIST_NAME_",
            id: "o_name",
            sortable: true,
            sortId: "o_name",
            slot: "o_name",
          },
          {
            label: "_LBL_FOERDERORGANISATION_BEARBEITEN_LIST_KUERZEL_",
            id: "o_kbez",
            sortable: true,
            sortId: "o_kbez"
          },
          {
            label: "_LBL_FOERDERORGANISATION_BEARBEITEN_LIST_NUTZER_ANZAHL_",
            id: "anzahl_nutzer",
            sortable: true,
            sortId: "anzahl_nutzer",
          },
        ],
        rowActions: [
          {
            label: "_LBL_FOERDERORGANISATION_BEARBEITEN_TABLE_ROW_ACTIONS_DETAILS_",
            route: "root.foerderorganisationen.details",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [],
        label: "_LBL_FOERDERORGANISATION_BEARBEITEN_LIST_",
        sortable: true,
        pagination: true,
        details: true,
        view: {
          filter: "top",
          details: "right",
        },
      },
      filters: [
        {
          type: "text",
          id: "o_name",
          label: "_LBL_FOERDERORGANISATION_BEARBEITEN_LIST_NAME_",
          main: true,
        },
        {
          type: "text",
          id: "o_kbez",
          label: "_LBL_FOERDERORGANISATION_BEARBEITEN_LIST_KUERZEL_",
        },
        {
          type: "numberrange",
          id: "anzahl_nutzer",
          label: "_LBL_FOERDERORGANISATION_BEARBEITEN_LIST_ANZAHL_NUTZER_",
        },
      ],
    };
  },
  computed: {
    getSlotNameTableDetails() {
      return `${ this.tableId }_table_details`;
    },

    getSlotNameTableDetailsHeader() {
      return `${ this.options.id }_table_details_header`;
    },
  },
};
